/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import React from "react";
import {ServiceDrivenDropDownFieldEditor} from "./ServiceDrivenDropDownFieldEditor";
import {service as ActivityFeedFilterService} from "../../../Services/ActivityFeedFilterService";

export const ActivityFeedFilterPicker = ServiceDrivenDropDownFieldEditor(ActivityFeedFilterService);

export const ActivityFeedFilterFieldEditor = (props) => {
	
	const emptyValueOption = [{
		key: 0,
		value: null,
		title: 'All',
	}];
	
	return <ActivityFeedFilterPicker
		additionalOptions={emptyValueOption}
		{...props}
	/>
	
}

